import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-05/lesson-29/task-03";

const task: Slide = {
  title: `Which of these elements can attenuate noise in ventilation systems?`,
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
